import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { StripePaymentElementOptions } from "@stripe/stripe-js";
import { useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Spinner from "react-bootstrap/esm/Spinner";

interface CheckoutFormProps {
    onClose: () => void;
}

const CheckoutForm: React.FC<CheckoutFormProps> = ({ onClose }) => {
    const stripe = useStripe();
    const elements = useElements();

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!stripe || !elements) {
            return;
        }

        setIsLoading(true);

        try{
            const { error } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: `${window.location.origin}/cart`,
                },
            });

            if (!error) {
                onClose();
            }
            
            setIsLoading(false);
        } catch(error) {
            console.error("Payment error: ", error);
            setIsLoading(false);
        }    
    }

    const paymentElementOptions: StripePaymentElementOptions = {
        layout: "accordion",
        wallets:{
            applePay: 'auto',
            googlePay: 'auto',
        },
        defaultValues: {
            billingDetails: {
                address: {
                    country: 'AU', // sets default country to Australia
                },
            },
        },
    }

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" options={paymentElementOptions} />

            <Button type="submit" disabled={isLoading || !stripe || !elements} id="submit">
                <span id="button-text">
                {isLoading ? <Spinner animation="border" variant="light" /> : "Pay now"}
                </span>
            </Button>
        </form>
    );
};

export default CheckoutForm;
